// import '../../plugins/jquery.hasClasses.js';

//スクロールしたらbodyにis-scrolledを付与
window.addEventListener("scroll", () => {
  if(window.scrollY >= 1) {
    document.querySelector('body').classList.add("is-scrolled");
  } else {
    document.querySelector('body').classList.remove("is-scrolled");
  }
  
})


